import * as React from 'react';

import classNames from 'classnames';

import { Icon } from '@base/components/Icon';
import { counters } from '@base/utils';

import { Link } from '@ui';

import { IMainMenuItemProps } from './types';

import * as s from './MainMenuItem.scss';

export const MainMenuItem = (props: IMainMenuItemProps) => {
	const {
		className,
		title,
		icon,
		image,
		link,
		badge,
		onClick,
		counter,
		isOuterLink = true,
		isNotLink,
	} = props;

	const onLinkClick = (event: React.MouseEvent<HTMLAnchorElement>) => {
		if (counter) {
			counters.sendRB(counter);
		}
		if (onClick) {
			onClick(event);
		}
	};

	return <Link
		onClick={onLinkClick}
		className={classNames(s.block, className)}
		to={link}
		isAlwaysLink={!isNotLink}
		isSimpleLink={isOuterLink}
	>
		{icon && <Icon className={s.icon} glyph={icon}/>}
		{!icon && image &&
			<span
				className={classNames(s.icon, s.image)}
				style={{ backgroundImage: `url(${image})` }}
			/>
		}
		{title && <span className={s.title}>{title}</span>}
		{badge && <span className={s.badge}>{badge}</span>}
	</Link>;
};
